import { RootRoute } from "#src/routes/root";
import { RoutePath } from "#src/utils/route";

export const WorkersRoutePath = RootRoute.concat(
  new RoutePath({
    path: "/workers",
    title: "Workers",
    isPresentational: true,
  })
);
